import { Translations } from '../translations.types';

export const co: Translations = {
  flag: 'Bandera',
  shape: 'Forma',
  'Population & Currency': 'Pupulazione è Muneta',
  'Capital flag': 'Capitale',
  emblem: 'Stemma',
  neighbours: 'Vicini',
  placeholder: 'Paese\u200by, territoriu...',
  guess: 'Induvinà',
  share: 'Spartite i risultati',
  'unknown-country': 'Paese scunnisciutu!',
  copy: 'Risultati copiati in u clipboard',
  'daily-end': {
    'well-done': 'Bellu travagliu !',
    'better-luck': 'Megliu furtuna dumane !',
    finished: 'Avete finitu a partita d’oghje.',
    score: 'Puntighju',
    'avg-guesses': 'Prove mediane',
    percentile: 'Percentile',
    'share-score': 'Sparte u vostru puntighju',
    replay: 'Ghjucà torna',
    results: 'Vede i risultati di u ghjornu',
    summary: 'Riassuntu',
    attempts: 'Vede e prove',
  },
  modes: {
    'city-flags': {
      title: 'Bandere di cità',
      'drop-here': 'Pusate a bandera quì',
      instruction: 'Trascinate ogni bandera versu a so cità',
      'ask-friend': 'Dumandà à un amicu',
      'play-now': 'Ghjucà à Bandere di cità',
      'share-question': 'Sapete chì cità rapresenta sta bandera ?',
      tray: 'Bandere',
      round: 'Manche {{current}}/{{total}}',
      correct: 'Ghjuste',
      wrong: 'Sbagliate',
      check: 'Verificà e risposte',
      continue: 'Seguente',
    },
    emblems: {
      title: 'Emblemi',
      'drop-here': 'Pusate l’emblema quì',
      instruction: 'Trascinate ogni emblema versu u so paese',
      'ask-friend': 'Dumandà à un amicu',
      'play-now': 'Ghjucà à Emblemi',
      'share-question': 'Sapete à chì paese appartene st’emblema ?',
      tray: 'Emblemi',
      round: 'Manche {{current}}/{{total}}',
      correct: 'Ghjuste',
      wrong: 'Sbagliate',
      check: 'Verificà e risposte',
      continue: 'Seguente',
    },
    accuracy: 'Precisione',
    'session-over': 'Partita compia !',
    'play-again': 'Ghjucà torna',
    'try-other': 'Prova {{mode}}',
    'back-to-daily': 'Torna à u ghjocu di u ghjornu',
    'load-failed': 'Ùn si pò caricà e dumande. Prova torna più tardi.',
  },
  header: {
    menu: {
      title: 'Menù',
      play: 'Ghjucà',
      help: 'Aiutu',
      open: 'Apre u menù',
      close: 'Chjode u menù',
    },
    new: 'Novu',
    beta: 'Beta',
    getPassport: 'Ottenere u passaportu',
  },
  footer: {
    tagline: 'FLAGLE - Indovina a bandera | Ghjocu di geografia ogni ghjornu',
    madeBy: 'Fattu cù ❤️ da Teuteuf',
  },
  sharing: {
    withFriends: "Spartite cù l'amichi",
    copyResult: 'Copià u risultatu',
    copyLink: 'Copià u ligame di sfida',
    linkCopied: 'Ligame di sfida copiatu in u clipboard',
    copyFailed: "Ùn s'hè pussutu copià — copiate à manu",
  },
  'play-bonus': 'Ghjochi a ronda bonus',
  'next-bonus': 'Prossima ronda bonus',
  'other-games': 'I nostri altri ghjochi:',
  'submit-feedback': 'Mandate un parè',
  'remaining-guesses': 'Vi ferma {{attemptsLeft}} pruvate',
  main: {
    'make-a-guess': 'Fate una supposizione per rivelà u primu tassellu',
    country: 'Paese...',
    flag: 'Bandera',
    'already-guessed': 'Avete dighjà indovinatu {{currentGuess}}',
  },
  quiz: {
    title: 'Pupulazione è Muneta',
    'estimated-population':
      'Chì ghjè a pupulazione stimata di {{countryName}}?',
    'guess-currency': 'Chì muneta si usa in {{countryName}}?',
    population: 'Pupulazione',
    currency: 'Muneta',
    micro: {
      'less-25': 'Meno di 25',
      over: 'Più di 2000',
    },
    small: {
      'first-option': '< 50 mila',
      'second-option': '50 - 500 mila',
      'third-option': '500k - 1 milione',
      'fourth-option': '1+ milione',
    },
    medium: {
      'first-option': '< 3 milioni',
      'second-option': '3 - 5 milioni',
      'third-option': '5 - 8 milioni',
      'fourth-option': '8+ milioni',
    },
    large: {
      'first-option': '< 15 milioni',
      'second-option': '15 - 25 milioni',
      'third-option': '25 - 35 milioni',
      'fourth-option': '35+ milioni',
    },
    massive: {
      'first-option': '< 60 milioni',
      'second-option': '60 - 80 milioni',
      'third-option': '80 - 100 milioni',
      'fourth-option': '100+ milioni',
    },
  },
  'shape-round': {
    title: 'Chì forma hà {{countryName}}',
    sponsored: 'Sponsorizatu da',
    like: 'Vi piace sta ronda',
    try: 'Pruvate',
  },
  'capital-flag': {
    title: 'Sceglite a bandera di a capitale di {{country}}: {{city}}',
  },
  'emblem-round': {
    title: "Sceglite l'emblema naziunale di {{countryName}}",
  },
  border: {
    title: "Sceglite a bandera d'un paese vicinu à {{countryName}}",
  },
  settings: {
    title: 'Impostazioni',
    'distance-unit': 'Unità di distanza',
    theme: 'Tema',
    language: 'Lingua',
    'difficulty-modifiers': 'Modificatori di difficultà',
    grayscale: 'Bandera in scala di grisgiu',
  },
  stats: {
    title: 'Statìstiche',
    played: 'Ghjochi fatti',
    win: 'Percentuale di vittoria',
    currentStreak: 'Serie attuale',
    maxStreak: 'Serie massima',
    guessDistribution: 'Distribuzione di supposizioni',
    donate: "🇺🇦 Donate à l'Ucraina ❤️",
  },
  'how-to-play': {
    title: 'Cumu ghjucà',
    guess: 'Induvinate u',
    'number-guesses': 'in 6 pruvati.',
    'valid-country': 'Ogni pruvata deve esse un paese o territoriu validu.',
    'after-guess':
      'Dopu ogni pruvata, riceverete a distanza, a direzzione è a vicinanza trà a vostra scelta è u locu di destinazione.',
    examples: 'Esempii',
    'your-guess': 'A vostra pruvata',
    is: 'hè',
    away: 'luntanu da u locu di destinazione, chì si trova à u nordeste, è avete solu 32% di vicinanza perchè hè abbastanza luntanu.',
    'second-guess': 'A vostra seconda pruvata',
    'getting-closer': 'si avvicina! À {{distance}}, direzzione sudeste è 83%!',
    'next-guess': 'Prossima pruvata,',
    'right-guess': 'hè u locu à indovinà! Complimenti',
    'new-game': 'Un novu',
    available: 'sarà dispunibule ogni ghjornu!',
    suggestions: 'Qualchì domanda o suggerimentu?',
    check: 'Cunsultate u',
    faq: 'FAQ Flagle',
    privacy: 'Pulitica di privacy',
    manageConsent: 'Gestisce u cunsensu',
    changePrivacySettings:
      "Pudete cambià e vostre preferenze di privacy clicchendu nant'à u buttone seguente:",
  },
  faq: {
    'when-new-game-available': {
      question: 'Quandu hè dispunibule un novu ghjocu?',
      answer:
        'Un novu ghjocu hè dispunibule ogni ghjornu à 0:00, ora lucale di u vostru dispositivu!',
    },
    'how-earn-bonus-round': {
      question: "Cumu possu ottene l'accessu à a prossima manche bonus?",
      answer:
        'Per ottene a prima manche bonus (forma), basta à indovinà currettamente u paese.',
    },
    'why-data-incorrect': {
      question: 'Perchè i vostri dati sò sbagliati o obsoleti?',
      answer:
        'Provu à aghjurnà i dati u più prestu è u più precisamente pussibule. Sapemu chì e fruntiere cambianu, e capitale si spostanu, è e carte diventanu obsolete. Ogni errore hè cumplettamente involuntariu è ùn raprisenta micca una dichjarazione pulitica. Apprezzemu i vostri feedback è correggeremu i sbagli appena i cunniscimu. Cù u tempu, ci serà di menu in menu da curregge.',
    },
    'where-previous': {
      question: 'Induve possu truvà i Flagle precedenti?',
      answer:
        "Per accede à l'archiviu di i ghjochi, create un contu Teuteuf Games è sottuscrivite à l'abbunamentu Premium Membership. U contu vi permetterà dinù di salvà e vostre statistiche è di ghjucà nant'à parechji dispositivi.",
    },
    'green-yellow-squares': {
      question: 'Chì significanu i quadrati verdi è gialli?',
      answer:
        'Currispondenu à a percentuale di vicinanza:<br><br>• 🟩 = 20%<br>• 🟨 = 10%',
    },
    'proximity-percent': {
      question: 'Chì hè a percentuale di vicinanza?',
      answer:
        "Hè un altru modu per riprisentà a distanza.<br><br>Sè u vostru suppostu hè à l'altru latu di u mondu, uttenerete 0%.<br>S'ellu hè esattamente nantu à u scopu, uttenerete 100%!",
    },
    'how-distances-computed': {
      question: 'Cumu sò calculate e distanze?',
      answer:
        "E distanze mostrate currispondenu à e distanze trà i centri di u territoriu selezziunatu è quellu miratu.<br><br>Per esempiu, a distanza calculata trà i Stati Uniti è u Canada hè di circa 2260 km, ancu s'elli anu una fruntiera cumuna.<br><br>Dui motivi per sta scelta:<br><br>• Hè tecnicamente assai più faciule di calculà a distanza cusì invece d'utilizà e fruntiere più vicine.<br><br>• Pudete deduce infurmazioni nantu à a dimensione di u paese miratu grazia à sta infurmazione.",
    },
    'why-not-valid-answer': {
      question: 'Perchè un certu paese ùn hè micca una risposta valida?',
      answer:
        "Adupru u standard ISO 3166-1 cum'è riferenza per a lista di codici di i paesi.<br><br>Per esempiu, a Scozia ùn hè micca una risposta valida, perchè secondu stu standard, stu paese face parte di u Regnu Unitu.",
    },
    'how-countries-picked': {
      question:
        'Cumu sò scelti i paesi è i territorii? Chì accadrà quandu tutti i paesi seranu stati scelti?',
      answer:
        "Ogni ghjornu, un paese o un territoriu hè sceltu à l'azardu!<br><br>Dunque, continuerà à sceglie unu à casu ogni ghjornu, per sempre!<br><br>Dui reguli sò stati aghjunti:<br><br>• Ùn sceglie micca un paese o un territoriu di menu di 5.000 km² s'ellu hè statu sceltu unu cù menu di 7 ghjorni fà.<br>• Ùn sceglie micca un paese chì hè statu sceltu cù menu di 100 ghjorni fà.<br>• Ùn sceglie micca un paese di u stessu cuntinente di quellu di eri (vale solu per l'Africa è l'Asia).",
    },
    'why-ads': {
      question: "Perchè vecu publicità nant'à u mo dispositivu?",
      answer:
        "Aduprà publicità per copre i costi di sviluppu per nuove funzionalità, ospitalità è altre spese. Cù u tempu, @teuteuf hà ricevutu parechje suggerimenti è richieste chì ùn pudia micca risponde. Vulemu purtà più funziunalità è una sperienza di ghjocu più divertente per VOI. U nostru pianu hè di purtà una applicazione mobile ufficiale è numerose funziunalità bonus per mantene Flagle cum'è u ghjocu quiz geograficu più divertente nantu à Internet!",
    },
  },
  account: {
    title: 'Contu',
    loggedIn: {
      hi: 'Bonghjornu',
      text: 'Avà stoccamu e statistiche vostra dopu ogni partita. Ùn protegge micca solu u vostru prucessu, ma ancu vi permette un ghjocu senza interruzioni trà parechji dispositivi.',
      learnMore: 'Sapene di più',
      signOut: 'Disconnettiti',
      manageAccount: 'Gestisci contu',
      premiumLabel: 'Teuteuf Passport',
    },
    loggedOut: {
      text: 'Iscribbiti per un contu di Teuteuf Games o cunnettiti per inizià à salvà e statistiche di ghjocu è à ghjucà trà parechji dispositivi. Vulete sapene tutti i benefici?',
      discoverMoreHere: 'Scoprite più qui',
      signUp: 'Iscriviti',
      login: 'Cunnettiti',
      loginWith: 'Accedi cù {{platform}}',
    },
  },
  member: {
    becomeMember: 'Diventate Membru Premium Teuteuf',
    noAds: 'Nisuna publicità',
    replayGames: 'Rigiucà i ghjochi',
    playArchive: "Ghjucà l'archiviu",
    dedicatedSupport: 'Supportu dedicatu',
    signUp: 'Iscriviti avà',
  },
  archive: {
    archive: 'Archiviu',
    archiveMode: 'Modu Archiviu',
    returnToToday: "Ritornu à u ghjocu d'oghje",
    playArchive: "Ghjucà l'archiviu",
    accessArchive:
      "L'accessu à l'archiviu di i ghjochi hè riservatu à i Passport Membri. Registratevi cù u ligame quì sottu è sbluccate a pussibilità di ghjucà à tutti i ghjochi chì sò mai esistiti!",
    gamesSince:
      "Eccu tutti i ghjochi Flagle dapoi u {{date}}. Cliccate nant'à un ghjocu per ghjucà quellu ghjornu.",
    playRandom: 'Ghjucà un ghjocu à casu',
    wantToPlayPrevious: 'Vulete ghjucà à i ghjochi precedenti di FLAGLE ?',
    replayTodaysGame: "Rigiucà a partita d'oghje",
    replayGame: 'Rigiucà u ghjocu',
    replayGames: 'Rigiucà i ghjochi',
    accessReplay:
      'A pussibilità di rigiucà i ghjochi hè riservata à i Passport Membri. Iscrivitevi cù u ligame quì sottu è sbluccate tutti i ghjochi chì sò mai esistiti!',
  },
  commonPhrases: {
    removeAds: "Eliminà l'annunzii",
  },
};
